import fetch from 'utils/fetch';
import { fetchSites } from './sites';
import { fetchContacts } from './contacts';
import { createAction } from 'redux-actions';

export const REQUEST_FORM = 'REQUEST_FORM';
export const RECEIVE_FORM = 'RECEIVE_FORM';
export const FORM_CASE_NAME_UPDATE = 'FORM_CASE_NAME_UPDATE';
export const FORM_CASE_TYPE_UPDATE = 'FORM_CASE_TYPE_UPDATE';
export const FORM_EXISTING_CASE_TYPE_UPDATE = 'FORM_EXISTING_CASE_TYPE_UPDATE';

export const requestFormAction = createAction('REQUEST_FORM');
export const receiveFormAction = createAction('RECEIVE_FORM');
export const caseNameUpdateAction = createAction('FORM_CASE_NAME_UPDATE');
export const existingCaseTypeUpdateAction = createAction(
  'FORM_EXISTING_CASE_TYPE_UPDATE'
);
export const caseTypeUpdateAction = createAction('FORM_CASE_TYPE_UPDATE');
export const existingInstallYearUpdateAction = createAction(
  'FORM_EXISTING_INSTALL_YEAR_UPDATE'
);
export const existingStateUpdateAction = createAction(
  'FORM_EXISTING_STATE_UPDATE'
);

function fetchForm(id) {
  return dispatch => {
    dispatch(requestFormAction());
    fetch(`/pco-manager/aast/cases-creation/${id}/step1.json`)
      .then(r => r.json())
      .then(nodes => {
        dispatch(receiveFormAction(nodes));
        dispatch(fetchSites(nodes.customerId));
        dispatch(fetchContacts(nodes.customerId));
      });
  };
}

function shouldFetchForm(id, state) {
  const form = state.form;

  if (form.customerId === undefined && id > 0 && !form.isFetching) {
    return true;
  }

  return false;
}

export const fetchFormIfNeeded = id => (dispatch, getState) => {
  const state = getState();
  if (shouldFetchForm(id, state)) {
    dispatch(fetchForm(id));
  }
};

export const updateExistingCaseType = value => (dispatch, getState) =>
  dispatch(existingCaseTypeUpdateAction(value));

export const updateCaseType = value => (dispatch, getState) =>
  dispatch(caseTypeUpdateAction(value));

export const updateName = value => (dispatch, getState) =>
  dispatch(caseNameUpdateAction(value));

export const updateExistingInstallYear = value => (dispatch, getState) =>
  dispatch(existingInstallYearUpdateAction(value));

export const updateExistingState = value => (dispatch, getState) =>
  dispatch(existingStateUpdateAction(value));



// WEBPACK FOOTER //
// ./src/modules/saas/aast/cases-creation/step1/actions/form.js